export const PROFESSIONAL_TYPE_MAP_BY_COUNCIL = {
  CRO: 'DENTISTA',
  COREN: 'ENFERMEIRO',
  CREFITO: 'FISIOTERAPEUTA',
  CREFONO: 'FONOAUDIOLOGO',
  CRM: 'MEDICO',
  CRN: 'NUTRICIONISTA',
  CRP: 'PSICOLOGO',
  CFESS: 'ASSISTENTE_SOCIAL',
  CONTER: 'TECNICO_RADIOLOGIA',
  CFBM: 'BIOMEDICO',
  HC: 'HEALTH_COACH',
  CREF: 'EDUCADOR_FISICO',
}
